var _excluded = ["as", "children", "color", "elevation", "fill", "href", "loading", "pending"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import MuiLoadingButton from '@material-ui/lab/LoadingButton';
import { colorMap, StyledButton } from './StyledButton';
function Button(_ref) {
  var as = _ref.as,
    children = _ref.children,
    color = _ref.color,
    elevation = _ref.elevation,
    fill = _ref.fill,
    href = _ref.href,
    loading = _ref.loading,
    pending = _ref.pending,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var anchorProps = {};
  var loadingProps = {};
  if (as === 'a') {
    anchorProps = {
      href: href
    };
  }
  if (loading) {
    var indicatorSizeMap = {
      large: 27,
      medium: 23,
      small: 20
    };
    loadingProps = {
      pending: !!pending,
      pendingIndicator: /*#__PURE__*/React.createElement(MuiCircularProgress, {
        color: "inherit",
        size: indicatorSizeMap[rest.size]
      })
    };
  }
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    disableElevation: !elevation,
    disableRipple: true,
    disableFocusRipple: true,
    component: loading ? MuiLoadingButton : as,
    fullWidth: fill,
    origcolor: color === 'inherit' ? 'default' : color,
    color: colorMap(color)
  }, rest, loadingProps, anchorProps), children);
}
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The component used for the root node. Either a string to use a HTML element or a component.
   */
  as: PropTypes.oneOf(['a', 'button']),
  /**
   * Component, node or text
   */
  children: PropTypes.node.isRequired,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['inherit', 'primary', 'primaryAlt', 'secondary', 'secondaryAlt', 'tertiary', 'error']),
  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,
  /**
   * Make button edges rounded or square
   */
  edges: PropTypes.oneOf(['normal', 'rounded', 'sharp']),
  /**
   * If `true`, no elevation is used.
   */
  elevation: PropTypes.bool,
  /**
   * Element placed before the children.
   */
  endIcon: PropTypes.node,
  /**
   * If `true`, the button will take up the full width of its container.
   */
  fill: PropTypes.bool,
  /**
   * The URL to link to when the button is clicked. If defined, an a element will be used as the root node.
   */
  href: PropTypes.string,
  /**
   * If `true`, Renders as `LoadingButton` component.
   * Available in version >= 5
   *
   * https://material-ui.com/api/loading-button/
   */
  loading: PropTypes.bool,
  /**
   * If `true`, Shows button in loading state
   */
  pending: PropTypes.bool,
  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['large', 'medium', 'small']),
  /**
   * Element placed after the children.
   */
  startIcon: PropTypes.node,
  /**
   * Defines the HTML `type` attribute of button
   */
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['contained', 'outlined', 'text', 'link'])
} : {};
Button.defaultProps = {
  as: 'button',
  color: 'inherit',
  disabled: false,
  edges: 'rounded',
  elevation: false,
  endIcon: '',
  fill: false,
  href: '',
  loading: false,
  pending: false,
  size: 'medium',
  startIcon: '',
  type: 'button',
  variant: 'contained'
};
export default Button;